import { ErrorTagName } from 'src/shared/constants';
import { useErrorTag } from 'src/shared/hooks';
import { isMobileApp } from 'src/shared/utils/environment';

const useMobileErrorTracking = () => {
  const trackMobileData = isMobileApp() && window.HOVERApp;

  const appVersion = trackMobileData ? window.HOVERApp?.version : undefined;

  useErrorTag(ErrorTagName.HOVER_APP_VERSION, appVersion);
};

export { useMobileErrorTracking };
